var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    staticClass: "mt-0",
    attrs: {
      "single-line": "",
      clearable: "",
      label: _vm.label,
      loading: _vm.loading,
      value: _vm.value,
      disabled: _vm.disabled,
      items: _vm.drivers,
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      change: function($event) {
        return _vm.$emit("change", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(data) {
          return [
            _c("bqa-certificate-icon", {
              attrs: { small: "", driver: data.item }
            }),
            _vm._v("\n    " + _vm._s(data.item.name) + "\n  ")
          ]
        }
      },
      {
        key: "prepend-inner",
        fn: function(data) {
          return [
            _c("bqa-certificate-icon", {
              attrs: { small: "", driver: data.item }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2c84318", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2c84318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectDriver.vue
// module id = null
// module chunks = 